import { Config } from 'mixpanel-browser';

type MixpanelApiRoutes = {
  record: string;
} & Config['api_routes'];

export type MixpanelInitConfig = {
  api_routes?: MixpanelApiRoutes;
} & Omit<Partial<Config>, 'api_routes'>;

type MixpanelConfigOptions = {
  isWhiteLabel: boolean;
  proxyUrl?: string;
};

const baseConfig: MixpanelInitConfig = {
  cross_subdomain_cookie: true,
  debug: false,
  record_sessions_percent: 1,
};

export const createMixpanelConfig = ({ isWhiteLabel, proxyUrl }: MixpanelConfigOptions): MixpanelInitConfig => {
  const normalizedProxyUrl = proxyUrl?.trim().replace(/\/+$/, '');

  if (!normalizedProxyUrl || isWhiteLabel) {
    return { ...baseConfig };
  }

  return {
    ...baseConfig,
    api_host: normalizedProxyUrl,
    api_routes: {
      engage: 'p/',
      groups: 'g/',
      record: 'r/',
      track: 'e/',
    },
  };
};
